<sm-title-bar
  pageTitle="Customer details"
  [back]="true"
  [headerCustomTemplate]="addButton"
>
  <ng-template #addButton>
    <div class="search_pag">
      <div class="opert_section">
        <button
          mat-icon-button
          class="more-button"
          aria-label="More options"
          [matMenuTriggerFor]="menu1"
        >
          <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #menu1="matMenu">
          <div *ngIf="!loader && customerData.length > 0">
            <button
              mat-menu-item
              (click)="createInvoice(customerData[0])"
              *ngIf="isAccessForEmployeeInvoice"
            >
              <mat-icon class="material-icons-outlined">playlist_add</mat-icon>
              <span>Create invoice</span>
            </button>
            <button mat-menu-item (click)="openAllBookings(customerData[0])">
              <mat-icon>list</mat-icon>
              <span>{{ "customers.op1" | translate }}</span>
            </button>
            <button mat-menu-item (click)="openAllPayments(customerData[0])">
              <mat-icon class="material-icons-outlined">receipt</mat-icon>
              <span>See all payments</span>
            </button>
            <button mat-menu-item (click)="openDueBookings(customerData[0])">
              <mat-icon class="material-icons-outlined"
                >pending_actions</mat-icon
              >
              <span>See due bills/invoices</span>
            </button>

            <button mat-menu-item (click)="openwallemoney(customerData[0])">
              <mat-icon class="material-icons-outlined">wallet</mat-icon>
              <span>Wallet transactions</span>
            </button>

            <button mat-menu-item (click)="openrewardpoint(customerData[0])">
              <mat-icon class="material-icons-outlined">card_giftcard</mat-icon>
              <span>Reward transactions</span>
            </button>
            <!-- (click)="servicereminder()" -->
            <!-- <button mat-menu-item>
             <mat-icon class="material-icons-outlined"
               >notification_add</mat-icon
             >
             <span>Service reminders</span>
           </button> -->

            <button
              mat-menu-item
              (click)="openPaymentIntimation(customerData[0])"
              *ngIf="customerData[0].total_due > 0 && isOwner"
            >
              <mat-icon class="material-icons-outlined">share</mat-icon>
              <span>{{ "customers.op3" | translate }}</span>
            </button>
            <!-- <button
             mat-menu-item
             (click)="editCustomer(customerData[0])"
             *ngIf="isOwner"
           >
             <mat-icon class="material-icons-outlined">edit</mat-icon>
             <span>Edit Customer</span>
           </button> -->
            <button
              mat-menu-item
              (click)="deleteCustomer(customerData[0])"
              *ngIf="isOwner"
            >
              <mat-icon class="material-icons-outlined">delete</mat-icon>
              <span>Delete Customer</span>
            </button>
          </div>
        </mat-menu>
      </div>
    </div>
  </ng-template>
</sm-title-bar>
<div class="member_details_view" *ngIf="!loader && customerData.length > 0">
  <div class="container">
    <div class="row">
      <div class="col-sm-8">
        <div class="salon_mei_section">
          <mat-card>
            <div class="exert_opd">
              <div
                class="opert_section"
                style="margin-right: 22px; padding-top: 10px"
              >
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="menu2"
                  class="more-button"
                  aria-label="More options"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu2="matMenu">
                  <button
                    mat-menu-item
                    (click)="editCustomer(customerData[0])"
                    *ngIf="isOwner"
                  >
                    <mat-icon class="material-icons-outlined">edit</mat-icon>
                    <span>Edit Customer</span>
                  </button>
                  <!-- <button mat-menu-item>
                              <mat-icon class="material-icons-outlined"
                                 >assessment</mat-icon
                                 >
                              <span>Show fitness data</span>
                           </button> -->
                </mat-menu>
              </div>
              <div class="member_details_iopen">
                <div class="salon_img">
                  <img
                    [src]="customerData[0].image_thumb_url"
                    onerror="
                      this.src = '../../../../assets/images/user-avatar.svg'
                    "
                    alt=""
                  />
                </div>
                <div class="fill_section">
                  <div class="hair_ct_heading">
                    <div class="rahul_headert">
                      <h4>{{ customerData[0].name }}</h4>
                      <p>
                        {{ customerData[0].country_code }}
                        {{ customerData[0].phone }}
                      </p>
                    </div>
                  </div>
                  <div class="rahul_headert menbrtr">
                    <div class="new_employ">
                      <p>
                        {{
                          customerData[0].email &&
                          customerData[0].email != "null" &&
                          customerData[0].email != ""
                            ? customerData[0].email
                            : "No email added"
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="active_cardt" style="display:flex;">
                        <p style="margin-right: 35px;">
                           <span class="activemember"></span>
                           <span class="member_list">Active</span>
                        </p>
                        <p style="margin-right: 35px;">
                           <span class="waletstatucmember"></span>
                           <span class="member_list">Wallet money: ₹5422.00</span>
                        </p>
                        <p>
                           <span class="waletstatucmember"></span>
                           <span class="member_list">Reward point:400</span>
                        </p>
                     </div> -->
            </div>
          </mat-card>
        </div>

        <mat-card class="member-info-card">
          <!-- Row 1 -->
          <div class="info-row">
            <div class="info-item">
              <mat-icon class="info-icon">wc</mat-icon>
              <div>
                <label>Gender</label>
                <span>{{ customerData[0].gender1 }}</span>
              </div>
            </div>

            <div class="divider"></div>

            <div class="info-item">
              <mat-icon class="info-icon">calendar_today</mat-icon>
              <div>
                <label>DOB</label>
                <span>{{
                  customerData[0].dob ? (customerData[0].dob | date) : "---"
                }}</span>
              </div>
            </div>
          </div>

          <mat-divider></mat-divider>

          <!-- Row 2 -->
          <div class="info-row">
            <div class="info-item">
              <mat-icon class="info-icon">lock_clock</mat-icon>
              <div>
                <label>Last booking</label>
                <span>{{
                  customerData[0].last_booking_date
                    ? (customerData[0].last_booking_date | date)
                    : "---"
                }}</span>
              </div>
            </div>

            <div class="divider"></div>

            <div class="info-item">
              <mat-icon class="info-icon">account_balance_wallet</mat-icon>
              <div>
                <label>Payment due</label>
                <span class="amount"
                  >{{ customerData[0].currency_symbol
                  }}{{ customerData[0].total_due.toFixed(2) }}</span
                >
              </div>
            </div>
          </div>
        </mat-card>

        <div class="workout_timiing_open">
          <div class="booking_name_opop">
            <h1 style="margin-bottom: 6px">Notes</h1>
          </div>
          <div class="member_paragr">
            <p>
              {{
                customerData[0].notes &&
                customerData[0].notes != "" &&
                customerData[0].notes != "null"
                  ? customerData[0].notes
                  : "No notes added"
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <!-- <div class="wallet-card">
    <div class="wallet-row">

      <div class="wallet-icon wallet-bg">
        <mat-icon>account_balance_wallet</mat-icon>
      </div>

      <div class="wallet-info">
        <h4>Wallet money</h4>
        <mat-chip-list>
          <mat-chip class="wallet-chip">₹5,422.00</mat-chip>
        </mat-chip-list>
      </div>

    </div>
  </div>
  <div class="wallet-card mt-3">
    <div class="wallet-row">

      <div class="wallet-icon reward-bg">
        <mat-icon>stars</mat-icon>
      </div>

      <div class="wallet-info">
        <h4>Reward points</h4>
        <mat-chip-list>
          <mat-chip class="wallet-chip">400</mat-chip>
        </mat-chip-list>
      </div>
    </div>
  </div> -->
        <mat-card class="info-card">
          <!-- Gender Row -->
          <div class="info-row">
            <div class="icon-box gender changecoloricon">
              <mat-icon>card_giftcard</mat-icon>
            </div>

            <div class="text-box ">
              <span class="label">Wallet money</span>
              <span
                class="value"
                *ngIf="customerData[0]?.total_wallet?.wallet_total_amount"
                >{{ customerData[0].currency_symbol
                }}{{
                  customerData[0].total_wallet.wallet_total_amount.toFixed(2)
                }}</span
              >
              <span
                class="value"
                *ngIf="!customerData[0]?.total_wallet?.wallet_total_amount"
                >{{ customerData[0].currency_symbol }}0.00</span
              >
            </div>
          </div>

          <mat-divider></mat-divider>

          <!-- Last Booking Row -->
          <div class="info-row">
            <div class="icon-box booking changecoloricon">
              <mat-icon>emoji_events</mat-icon>
            </div>

            <div class="text-box">
              <span class="label">Reward points</span>
              <span class="value">{{
                customerData[0].total_reward ? customerData[0].total_reward : 0
              }}</span>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
